import { importStylingAsset } from '../utils/styling/styling.utils';
export default function () {
  importStylingAsset('https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined');
}
